import {useState, useEffect} from 'react';
import { Grid } from "@mui/material"

import UpdateProductStatusAPI from './UpdateProductStatusAPI';
export default function UpdateproductstatusActionImpl(){

    return (
        <Grid sx={{width:'100%'}}>
            <UpdateProductStatusAPI/>
        </Grid>
    )
}